import { MedicationStockReason } from '../types'

export const getActionTitle = (
  reason: MedicationStockReason,
  t: (key: string) => string
): string => {
  switch (reason) {
    case MedicationStockReason.STOCK_COUNT:
      return t('STOCK_CHECK')
    case MedicationStockReason.WASTE:
      return t('DISPOSAL')
    case MedicationStockReason.RESTOCK:
      return t('DELIVERY')
    case MedicationStockReason.MED_ADMIN:
      return t('ADMINISTERED')
    default:
      return reason.replace(/_/g, ' ')
  }
}

export const getActionSubtitle = (
  reason: MedicationStockReason,
  quantityChange: number,
  unit: string,
  notes?: string | string[],
  t?: (key: string) => string
): string | undefined => {
  switch (reason) {
    case MedicationStockReason.STOCK_COUNT:
      return undefined
    case MedicationStockReason.NOT_ADMINISTERED:
      if (Array.isArray(notes)) {
        return notes.join(', ')
      }
      return notes || ''
    case MedicationStockReason.WASTE:
    case MedicationStockReason.RESTOCK:
    case MedicationStockReason.MED_ADMIN:
      const quantity = Math.abs(quantityChange || 0)
      const unitText = unit || (t ? t('TABLETS') : 'tablets')
      return `${quantity} ${unitText}`
    default:
      return undefined
  }
}
